module.exports = __webpack_public_path__ + "entry-150bfe9b/ottobock-photo-91f582c68b56812fe9bfe4b183c4f481.webp";